<template>
  <div>
    <h5 class="ml-0">{{ lgLabel }}</h5>
    <v-row class="my-1 mt-4">
      <v-col cols="2">
        <v-row>
          <v-card
            @click="handleUploadInspectionPicture"
            class="d-flex justify-center align-center"
            :style="{ width: '200px', height: '150px' }"
            :disabled="formDisabled"
          >
            <v-dialog
              v-model="dialog"
              max-width="60%"
            >
              <v-card>
                <v-card-title class="text-h5 mb-2">
                  {{ $t("categories.inspection.screenshots") }}
                </v-card-title>
                <v-card-subtitle>{{ $t("messages.information.click_to_add") }}</v-card-subtitle>
                <v-container>
                  <v-item-group
                    v-model="selectedPicture"
                    multiple
                  >
                    <v-row
                      class="justify-center"
                      v-if="unassignedPictures.length > 0"
                    >
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        v-for="(u, i) in unassignedPictures"
                        :key="i"
                      >
                        <v-item v-slot="{ active, toggle }">
                          <v-img
                            :src="u.file_url"
                            @click="
                              () => {
                                if (selectedPicture.length === 0 || selectedPicture.includes(i)) {
                                  toggle()
                                }
                              }
                            "
                            :style="{
                              filter:
                                selectedPicture.length === 0 || selectedPicture.includes(i)
                                  ? 'brightness(1)'
                                  : 'brightness(0.5)'
                            }"
                          >
                            <v-btn icon>
                              <v-icon v-if="selectedPicture.length > 0">
                                {{ active ? "mdi-check-circle" : "mdi-cancel" }}
                              </v-icon>
                            </v-btn>
                          </v-img>
                        </v-item>
                      </v-col>
                    </v-row>
                    <v-card-text v-else>
                      {{ $t("messages.information.no_picture_available") }}
                    </v-card-text>
                  </v-item-group>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="validate"
                    v-if="unassignedPictures.length > 0"
                    color="primary"
                  >
                    {{ $t("commons.validate") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <span class="grey--text text-center">
              <v-icon
                class="mb-3"
                size="60"
                color="grey"
              >
                mdi-image-plus
              </v-icon>
              <br />
              {{
                $t("actions.add_from_inspection", {
                  entity: $tc("commons.picture", 1).toLowerCase()
                })
              }}
            </span>
          </v-card>
        </v-row>
        <v-row>
          <v-card
            @click="handleUpload"
            class="mt-10 d-flex justify-center align-center"
            :style="{ width: '200px', height: '150px' }"
            :disabled="formDisabled"
          >
            <input
              v-show="false"
              type="file"
              multiple
              accept="image/*"
              ref="uploadInput"
              @change="handleChange"
            />
            <span class="grey--text text-center">
              <v-icon
                size="60"
                color="grey"
              >
                mdi-upload
              </v-icon>
              <br />
              {{ $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() }) }}
            </span>
          </v-card>
        </v-row>
      </v-col>
      <v-col
        class="ml-8"
        cols="10"
        sm="10"
        md="7"
      >
        <v-card v-if="picture.file_url">
          <div
            @mouseleave="picture.hover = false"
            @mouseenter="picture.hover = true"
            :style="{ position: 'relative' }"
          >
            <v-img
              :src="picture.file_url"
              height="300"
            ></v-img>
            <v-card-actions class="pt-0">
              <PictureEditor
                v-model="picture.file_url"
                :value="picture.gridApplied ? picture.file_url_with_grid : picture.file_url"
                @custom-event="handleCustomEvent"
                :key="`picture-editor-${picture.timestamp}`"
              >
                <template v-slot:activator="{ on, attrs }">
                  <avs-editButton
                    v-on="on"
                    :disabled="!editable"
                    :attrs="attrs"
                    :fab="!$vuetify.breakpoint.lgAndUp"
                    @input="$emit('input', picture)"
                    :spantext="
                      $t('actions.edit', { entity: $tc('commons.picture', 1).toLowerCase() })
                    "
                  />
                </template>
              </PictureEditor>
              <!-- <v-spacer></v-spacer> -->
              <avs-gridButton
                :disabled="!editable"
                @click.stop="applyGrid"
                :spantext="$t('actions.grid', { entity: $tc('commons.picture', 1).toLowerCase() })"
              />
            </v-card-actions>
          </div>
          <v-card-title class="py-0">
            <v-text-field
              v-model="picture.name"
              :rules="rules.name"
              :disabled="!editable"
              counter="1024"
              maxLength="1024"
              :placeholder="$t('commons.name')"
            ></v-text-field>
          </v-card-title>
          <v-textarea
            v-model="picture.description"
            :disabled="!editable"
            class="mx-2"
            counter="1024"
            maxLength="1024"
            :placeholder="$t('commons.description')"
          ></v-textarea>
          <v-card-actions
            style="display: inline"
            class="pt-0"
          >
            <div
              style="display: flex; justify-content: space-between"
              v-if="editable"
            >
              <avs-deleteButton
                class="ml-4"
                @click.stop="remove()"
                :spantext="
                  $t('actions.delete', { entity: $tc('commons.picture', 1).toLowerCase() })
                "
              />
              <div style="display: flex; justify-content: end">
                <v-btn
                  color="primary"
                  @click="savePicture"
                >
                  {{ $t("commons.save") }}
                </v-btn>
                <v-btn
                  color="error"
                  @click="cancel"
                  class="mx-4"
                >
                  {{ $t("commons.cancel") }}
                </v-btn>
              </div>
            </div>
            <avs-editButton
              v-else
              :disabled="formDisabled"
              @click.stop="v => (editable = true)"
              :spantext="$t('actions.edit', { entity: $tc('commons.picture', 1).toLowerCase() })"
            />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash"
import { imageValidator, required, max1024 } from "@/utils/validator"
import { InspectionService, PictureService } from "@/services"

export default {
  name: "ImageField",
  components: {
    PictureEditor: () => import("../../non-conformity/NonConformityPictureEditor.vue")
  },
  props: {
    formDisabled: { type: Boolean },
    label: { type: String, default: "" },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ fkey: "", name: "", description: "" }]
      }
    }
  },
  data() {
    return {
      inspectionId: this.$route.params.id,
      editable: false,
      dialog: false,
      unassignedPictures: [],
      selectedPicture: [],
      picture: {
        file_url: null,
        originalUrl: null,
        file_url_with_grid: null,
        gridApplied: false,
        hover: null,
        fkey: "",
        name: "",
        description: "",
        anotate: false,
        timestamp: Date.now()
      },
      savedPicture: {},
      rules: {
        name: [required, max1024],
        description: [required, max1024]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    pValue: {
      get() {
        return this.values[0]
      }
    }
  },
  mounted() {
    this.setPicture()
  },
  methods: {
    handleUploadInspectionPicture() {
      InspectionService.unassignedPictures
        .getAll(this.inspectionId)
        .then(r => {
          this.unassignedPictures = r.results
        })
        .finally(() => (this.dialog = true))
    },
    handleCustomEvent(base64str) {
      this.picture.file_url = base64str
      this.picture.anotate = true
    },
    handleChange(e) {
      Array.from(e.target.files).forEach((picture, i) => {
        if (imageValidator(picture)) {
          let reader = new FileReader()

          reader.addEventListener(
            "load",
            () => {
              this.picture = {
                file_url: reader.result,
                fkey: null,
                name: null,
                description: null
              }
              this.editable = true
            },
            false
          )
          if (picture) {
            reader.readAsDataURL(picture)
          }
        }
      })
    },
    handleUpload() {
      this.$refs.uploadInput.click()
    },
    handleUpdate() {
      const newValue = [
        {
          id: 0,
          fkey: this.picture.fkey,
          name: this.picture.name,
          description: this.picture.description
        }
      ]
      this.$emit("input", newValue)
    },
    validate() {
      const res = this.unassignedPictures[this.selectedPicture]
      this.picture = {
        file_url: res.file_url,
        hover: false,
        fkey: res.id,
        name: "",
        description: ""
      }
      this.dialog = false
      this.editable = true
    },
    setPicture() {
      if (this.pValue.fkey) {
        PictureService.getPicture(this, this.pValue.fkey).then(r => {
          this.picture = {
            file_url: r.file_url,
            fkey: this.pValue.fkey,
            name: this.pValue.name,
            description: this.pValue.description
          }
        })
      }
    },
    savePicture() {
      if (!this.picture.name || !this.picture.description) {
        this.$store.commit("app/message", {
          msg: this.$t("messages.warning.all_required_info"),
          color: "error"
        })
      } else {
        if (!this.picture.fkey) {
          PictureService.createPicture({
            inspection: this.inspectionId,
            files: [
              {
                file: this.picture.file_url,
                name: this.picture.name,
                description: this.picture.description
              }
            ]
          }).then(r => {
            this.picture.fkey = r.files[0].id
            this.savedPicture = _.cloneDeep(this.picture)
            this.handleUpdate()
          })
        } else {
          if (this.picture.anotate) {
            PictureService.createPicture({
              inspection: this.inspectionId,
              files: [
                {
                  file: this.picture.file_url,
                  name: this.picture.name,
                  description: this.picture.description
                }
              ]
            }).then(r => {
              this.picture.fkey = r.files[0].id
              this.savedPicture = _.cloneDeep(this.picture)
              this.handleUpdate()
            })
          } else {
            this.handleUpdate()
          }
        }
        this.editable = false
        this.savedPicture = _.cloneDeep(this.picture)
      }
    },
    cancel() {
      this.editable = false
      this.picture = _.cloneDeep(this.savedPicture)
    },
    remove() {
      this.picture = {
        file_url: null,
        hover: null,
        fkey: "",
        name: "",
        description: ""
      }
      this.savedPicture = _.cloneDeep(this.picture)
      this.editable = false
      this.handleUpdate()
    },
    applyGrid() {
      if (this.picture.gridApplied) {
        this.picture.file_url = this.picture.originalUrl
        this.picture.gridApplied = false
      } else {
        if (!this.picture.originalUrl) {
          this.picture.originalUrl = this.picture.file_url
        }

        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")
        const img = new Image()
        img.crossOrigin = "anonymous"
        img.src = this.picture.originalUrl

        img.onload = () => {
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)

          const cellSize = 50 // Taille de chaque cellule de la grille en pixels
          const divisionsX = Math.floor(canvas.width / cellSize)
          const divisionsY = Math.floor(canvas.height / cellSize)
          const stepX = canvas.width / divisionsX
          const stepY = canvas.height / divisionsY

          ctx.beginPath()
          for (let i = 0; i <= divisionsX; i++) {
            const x = i * stepX
            const letter = String.fromCharCode("A".charCodeAt(0) + i)
            ctx.moveTo(x, 0)
            ctx.lineTo(x, canvas.height)
            ctx.fillText(letter, x + 2, canvas.height - 5) // Positionner les lettres en bas
          }
          for (let i = 0; i <= divisionsY; i++) {
            const y = i * stepY
            ctx.moveTo(0, y)
            ctx.lineTo(canvas.width, y)
            ctx.fillText(i + 1, 5, canvas.height - y - 2) // Positionner les chiffres en bas
          }
          ctx.strokeStyle = "#000" // Couleur des lignes de la grille
          ctx.stroke()

          this.picture.file_url = canvas.toDataURL()
          this.picture.file_url_with_grid = this.picture.file_url
          this.picture.gridApplied = true
          this.picture.timestamp = Date.now()
        }
      }
    }
  },
  watch: {
    editable: {
      handler(newValue, oldValues) {
        this.$emit("disableButton", newValue)
        if (newValue && this.picture.fkey) {
          this.savedPicture = _.cloneDeep(this.picture)
        }
      },
      deep: true
    }
  }
}
</script>
